import { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";

/**
 * RevealText — masked line-by-line reveal.
 * Pass an array of lines; each line sits inside an overflow-hidden mask
 * and animates up from 100% with a stagger.
 */
export const RevealText = ({ lines = [], className = "", delay = 0, once = true }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once, margin: "-10%" });

  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className="block print-reveal"
            initial={{ y: "110%" }}
            animate={inView ? { y: "0%" } : { y: "110%" }}
            transition={{
              duration: 1.05,
              ease: [0.16, 1, 0.3, 1],
              delay: delay + i * 0.12,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

/** FadeUp — generic scroll reveal wrapper. */
export const FadeUp = ({ children, className = "", delay = 0, y = 40, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-8%" });
  return (
    <motion.div
      ref={ref}
      data-testid={testId}
      className={`print-reveal ${className}`}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
};
